import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    locations: [],
    supportedTypes: ['Retail', 'Restaurant', 'Distributor'],
    filters: {
      brands: [],
      types: []
    },
    place: null,
    bounds: null,
    defaultBrand: false
  },
  mutations: {
    addFilterValue: (state, { key, value }) => {
      let selected = state.filters[key] || [];
      if(selected.indexOf(value) === -1) {
        selected.push(value)
      }
      Vue.set(state.filters, key, selected);
    },
    removeFilterValue: (state, { key, value }) => {
      let selected = state.filters[key] || [];
      let index = selected.indexOf(value);
      if(index !== -1) {
        selected.splice(index, 1);
      }
      Vue.set(state.filters, key, selected);
    },
    clearFilterValues: (state) => {
      state.filters.brands = state.defaultBrand ? [state.defaultBrand] : [];
      state.filters.types = [];
    },
    setLoading: (state, isLoading) => {
      state.loading = isLoading;
    },
    setBounds: (state, bounds) => {
      state.bounds = bounds;
    },
    setPlace: (state, place) => {
      state.place = place;
    },
    setLocations: (state, locations) => {
      state.locations = locations;
    },
    setDefaultBrand: (state, defaultBrand) => {
      state.defaultBrand = defaultBrand;
      state.filters.brands.unshift(defaultBrand);
    }
  },
  actions: {
    viewportSearch: ({commit, dispatch, state}) => {
      if(state.bounds == null) {
        return;
      }
      //set the loading status
      commit('setLoading', true);

      //handle the default brand if set
      let brands = state.filters.brands;
      if (state.defaultBrand !== false && state.defaultBrand != null) {
        brands = [state.defaultBrand, ...state.filters.brands];
      }

      let body = {
        "page": 1,
        "per_page": 2000,
        "location": {
          "filter": "geo_bounding_box",
          "top_left": {
            "lat": state.bounds.ne.lat,
            "lon": state.bounds.sw.lng
          },
          "bottom_right": {
            "lat": state.bounds.sw.lat,
            "lon": state.bounds.ne.lng
          }
        },
        "brands": brands,
        "types": state.filters.types
      };

      // console.log('================================================');
      // console.log('GREEN ROVER', 'https://0mosudn32b.execute-api.us-east-1.amazonaws.com/search');
      // console.log('GREEN ROVER BODY', body);
      // console.log('================================================');

      axios
        .post("https://0mosudn32b.execute-api.us-east-1.amazonaws.com/search", body)
        .then(resp => {
          // console.log('================================================');
          // console.log('GREEN ROVER RESP', resp);
          // console.log('================================================');
          let locations = [];
          if (resp.data.hasOwnProperty('payload')) {
            if (resp.data.payload.hasOwnProperty('hits')) {
              // Handle Property Types
              if (resp.data.payload.hits.hasOwnProperty('hits')) {
                //iterate over the location types
                for (let tmp of resp.data.payload.hits.hits) {
                  // extract and reform each location
                  const {_id: id, _source: source} = tmp;
                  locations.push({
                    id: id,
                    ...source
                  });
                }
              }
            }
          }

          commit('setLocations', locations);
          commit('setLoading', false);
        })
        .catch(err => {
          commit('setLocations', []);
          commit('setLoading', false);
        });
    },
    geolocationSearch: ({commit, dispatch, state}, {lat, lng}) => {
      //set the loading status
      commit('setLoading', true);

      //handle the default brand if set
      let brands = state.filters.brands;
      if (state.defaultBrand !== false && state.defaultBrand != null) {
        brands = [state.defaultBrand, ...state.filters.brands];
      }

      let body = {
        "page": 1,
        "per_page": 2000,
        "location": {
          "filter": "geo_distance",
          "distance": "30mi",
          "lat": lat,
          "lon": lng
        },
        "brands": brands,
        "types": state.filters.types
      };

      axios
        .post("https://0mosudn32b.execute-api.us-east-1.amazonaws.com/search", body)
        .then(resp => {
          let locations = [];
          if (resp.data.hasOwnProperty('payload')) {
            if (resp.data.payload.hasOwnProperty('hits')) {
              // Handle Property Types
              if (resp.data.payload.hits.hasOwnProperty('hits')) {
                //iterate over the location types
                for (let tmp of resp.data.payload.hits.hits) {
                  // extract and reform each location
                  const {_id: id, _source: source} = tmp;
                  locations.push({
                    id: id,
                    ...source
                  });
                }
              }
            }
          }

          commit('setLocations', locations);
          commit('setLoading', false);
        })
        .catch(err => {
          commit('setLocations', []);
          commit('setLoading', false);
        });
    },
    addFilterValue: ({commit, dispatch, state}, {key, value}) => {
      commit('addFilterValue', {
        key,
        value
      });
      dispatch('viewportSearch');
    },
    removeFilterValue: ({commit, dispatch, state}, {key, value}) => {
      commit('removeFilterValue', {
        key,
        value
      });
      dispatch('viewportSearch');
    },
    clearFilterValues: ({commit, dispatch, state}) => {
      commit('clearFilterValues');
      dispatch('viewportSearch');
    },
    setBounds: ({commit, dispatch, state}, bounds) => {
      commit('setBounds', bounds);
      dispatch('viewportSearch');
    },
    setPlace: ({commit, dispatch, state}, place) => {
      //set the place object in the store
      commit('setPlace', place);

      //place.geometry.viewport
      if(place.hasOwnProperty('geometry')) {
        if(place.geometry.hasOwnProperty('viewport')) {
          let bounds = {
            sw: {
              lat: place.geometry.viewport.getSouthWest().lat(),
              lng: place.geometry.viewport.getSouthWest().lng()
            },
            ne: {
              lat: place.geometry.viewport.getNorthEast().lat(),
              lng: place.geometry.viewport.getNorthEast().lng()
            }
          };
          commit('setBounds', bounds);
          dispatch('viewportSearch');
        }
      }

      //  handle a HTML5 geolocation place
      if(place.coords) {
        let lng = place.coords.longitude;
        let lat = place.coords.latitude;
        dispatch('geolocationSearch', {lat, lng});
      }


    },
    setLoading: ({commit, dispatch, state}, loading) => {
      commit('setLoading', loading);
    },
    setDefaultBrand: ({commit, dispatch, state}, defaultBrand) => {
      commit('setDefaultBrand', defaultBrand);
    }
  },
  getters: {
    // get the locations as markers
    markers: function (state) {
      return state.locations.map(value => {
        const {id, type: types, address, phone, state: addr_state, name, location, zipcode, city} = value;
        const brands = value.brand.reduce((accumulator, current) => {
          if (state.filters.brands.indexOf(current) >= 0) {
            accumulator.push(current);
          }
          return accumulator;
        }, []);
        return {
          position: {
            lat: parseFloat(location.lat),
            lng: parseFloat(location.lon)
          },
          content: {
            id: id,
            name: name,
            brands: brands,
            types: types,
            address: address,
            city: city,
            state: addr_state,
            zipcode: zipcode,
            phone: phone
          }
        };
      });
    },
    // get the locations as cards
    cards: function (state) {
      return state.locations.map(value => {
        const {id, type: types, address, phone, state: addr_state, name, zipcode, city} = value;
        const brands = value.brand.reduce((accumulator, current) => {
          if (state.filters.brands.indexOf(current) >= 0) {
            accumulator.push(current);
          }
          return accumulator;
        }, []);
        return {
          id: id,
          name: name,
          brands: brands,
          types: types,
          address: address,
          city: city,
          state: addr_state,
          zipcode: zipcode,
          phone: phone
        };
      });
    },
  }
})
